import { render, staticRenderFns } from "./TheNoRecordOfMarriageForm.vue?vue&type=template&id=c91e9b86&scoped=true&"
import script from "./TheNoRecordOfMarriageForm.vue?vue&type=script&lang=js&"
export * from "./TheNoRecordOfMarriageForm.vue?vue&type=script&lang=js&"
import style0 from "./TheNoRecordOfMarriageForm.vue?vue&type=style&index=0&id=c91e9b86&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c91e9b86",
  null
  
)

export default component.exports